import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedFolder, selectSelectedId } from '../../../selectors/folders';
import { closeModalRemove } from '../../../actions/folders/actions';
import { deleteFolder } from '../../../thunk/favorites/deleteFolders';
import { ModalRemove } from '../../../components/FolderHeader/menu/ModalRemove';
import { trackRemoveFolder } from './tracking';
import { selectResults } from '../../../selectors';

export function ModalRemoveContainer() {
  const dispatch = useDispatch();
  const selectedFolderId = useSelector(selectSelectedId);
  const folder = useSelector(selectSelectedFolder);
  const { favoriteEntities } = useSelector(selectResults);

  const handleConfirm = () => {
    dispatch(closeModalRemove());

    if (!selectedFolderId || !folder) {
      return;
    }

    trackRemoveFolder(favoriteEntities);
    dispatch(deleteFolder(selectedFolderId));
  };

  return <ModalRemove isVisible={true} onConfirm={handleConfirm} onCancel={() => dispatch(closeModalRemove())} />;
}
